export const APP_ENV = 'development';
export const APP_DEBUG = true;
// A local build served behind a proxy sets these, so it talks to the API on its own origin.
export const APP_URL = process.env.REACT_APP_APP_URL ?? (process.env.NODE_ENV === 'production' ? 'https://api.pokemon.skylerfenn.com' : 'https://pokemon.test');
export const API_URL = `${APP_URL}/api`;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID ? Number(process.env.REACT_APP_CLIENT_ID) : 2;
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET ?? (process.env.NODE_ENV === 'production' ? 'w6efUu0o0msWT1qw3bdy0sxTq788jzOVI6N33bBf' : 'WJ0f62gYtdkbLNBC2OFuyoETdyLfGokxglE40h6l');
export const PUSHER_KEY = '5e475d1bb44c81943c11';
